/**
 * @param {unknown} values
 * @returns {boolean}
 */
function isEmpty(values) {
	if (values === null || values === undefined) {
		return true;
	}

	// @ts-ignore checks type to be object before grabbing keys
	if (typeof values === 'object' && Object.keys(values).length === 0) {
		return true;
	}

	if (
		(Array.isArray(values) || typeof values === 'string') &&
		values.length === 0
	) {
		return true;
	}

	return false;
}

/**
 * Check if a value is iterable.
 * @param {unknown} value
 * @returns {boolean}
 */
function isIterable(value) {
	if (value === null || value === undefined) {
		return false;
	}

	if (typeof value === 'object' && Symbol.iterator in value) {
		// @ts-ignore checked above
		return typeof value[Symbol.iterator] === 'function';
	}

	return false;
}

/**
 * @param {number} timeInMilliseconds
 * @returns {Promise<void>}
 */
async function sleep(timeInMilliseconds) {
	new Promise((resolve) => {
		setTimeout(resolve, timeInMilliseconds);
	});
}

module.exports = { isEmpty, isIterable, sleep };
